import { network } from 'services/network';

export const setTableColumns = (params) => {
    return network
        .post('api/bo/setTableColumns', params)
        .then((response) => (Boolean(response.data) ? response.data : null));
};
